/**
 * @generated SignedSource<<63a58c5c6fa8ac979de73490db3b8a72>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FinishLessonPlayInput = {
  lessonPlayId: string;
};
export type LessonPlayerFinishMutation$variables = {
  input: FinishLessonPlayInput;
};
export type LessonPlayerFinishMutation$data = {
  readonly finishLessonPlay: {
    readonly id: string;
  };
};
export type LessonPlayerFinishMutation = {
  response: LessonPlayerFinishMutation$data;
  variables: LessonPlayerFinishMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LessonPlay",
    "kind": "LinkedField",
    "name": "finishLessonPlay",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LessonPlayerFinishMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "LessonPlayerFinishMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "75993124883cf0309482cfd813086d12",
    "id": null,
    "metadata": {},
    "name": "LessonPlayerFinishMutation",
    "operationKind": "mutation",
    "text": "mutation LessonPlayerFinishMutation(\n  $input: FinishLessonPlayInput!\n) {\n  finishLessonPlay(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "98383daf18da0e8d85ebe3933170f0fa";

export default node;
